import { useEffect, useState } from "react";
import { Link } from "react-router";
import type { DeviceListItem } from "@handvero/shared";
import { api, errorText } from "../api";
import { Message } from "./ui";

/* „Geräte im Haus“: alle erfassten Gerätekarten mit Alter, Garantie und Wartung. Für Zuhause und Betrieb gleich. */

const day = (iso: string) => new Date(`${iso}T00:00:00`).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });

function age(year: string | null): string | null {
  const y = Number.parseInt(year ?? "", 10);
  const now = new Date().getFullYear();
  if (!Number.isFinite(y) || y < 1950 || y > now) return null;
  const n = now - y;
  return n === 0 ? "Baujahr dieses Jahr" : `${n} ${n === 1 ? "Jahr" : "Jahre"} alt`;
}

function warrantyText(until: string | null): { text: string; late: boolean } | null {
  if (!until) return null;
  const left = new Date(`${until}T00:00:00`).getTime() - Date.now();
  return left < 0 ? { text: `Garantie endete am ${day(until)}`, late: true } : { text: `Garantie bis ${day(until)}`, late: false };
}

export function DevicesView({ base }: { base: "/app" | "/desktop" }) {
  const [items, setItems] = useState<DeviceListItem[] | null>(null);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  useEffect(() => {
    api.get<DeviceListItem[]>("/api/devices").then(setItems, (err) => setError(errorText(err)));
  }, []);
  const q = query.trim().toLowerCase();
  const shown = (items ?? []).filter((d) => !q || `${d.name} ${d.manufacturer ?? ""} ${d.model ?? ""} ${d.serial ?? ""} ${d.place ?? ""}`.toLowerCase().includes(q));
  return (
    <div className="devices-view">
      <Message>{error}</Message>
      {items && items.length > 0 && (
        <input className="devices-search" type="search" placeholder="Gerät suchen" value={query} onChange={(e) => setQuery(e.target.value)} aria-label="Geräte durchsuchen" />
      )}
      {items && items.length === 0 && (
        <p className="muted-s">
          Noch kein Gerät erfasst. Öffnen Sie einen Ordner und tippen Sie auf „Gerät erfassen: Typenschild fotografieren“. Die Geräte erscheinen dann hier.
        </p>
      )}
      <ul className="devices-list">
        {shown.map((d) => {
          const w = warrantyText(d.warrantyUntil);
          const a = age(d.year);
          const meta = [d.manufacturer, d.model, d.serial ? `Nr. ${d.serial}` : null].filter(Boolean).join(" · ");
          return (
            <li key={d.id}>
              <Link to={`${base}/p/${d.projectId}/f/${d.folderId}`}>
                <b>{d.name}</b>
                {meta && <small>{meta}</small>}
                <small>
                  {[d.place, a, d.serviceMonths ? `Wartung alle ${d.serviceMonths} Monate` : null].filter(Boolean).join(" · ") || d.projectName}
                </small>
                {w && <small className={w.late ? "late" : ""}>{w.text}</small>}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
